export interface ConfirmDialogWithCommentProps {
    onConfirm: (comment?: string) => Promise<void>;
    header: string;
    message: string;
    acceptLabel?: string;
    rejectLabel?: string;
    commentPlaceholder?: string;
    showCommentField?: boolean;
    icon?: string;
}

let dialogHandler: ((props: ConfirmDialogWithCommentProps) => void) | null = null;

/** Назначает обработчик открытия диалога подтверждения. */
export const setConfirmDialogHandler = (handler: typeof dialogHandler) => {
    dialogHandler = handler;
};

/** Открывает подтверждение выбранного действия. */
export const showConfirmDialog = (props: ConfirmDialogWithCommentProps) => {
    dialogHandler?.(props);
};
